import React from 'react'
import { faSparkles } from '@document-crunch/pro-regular-svg-icons'
import { AI_GENERATED_LABEL } from '@dc-shared-web/lib'
import { Icon, Tooltip } from '@dc-shared-web/components/base/index'

export const GeneratedByAiIcon: React.FC = () => {
  return (
    <Tooltip content={AI_GENERATED_LABEL} withArrow>
      <div>
        <Icon icon={faSparkles} size='lg' className='tw-text-purple-700' />
      </div>
    </Tooltip>
  )
}

export default GeneratedByAiIcon
